import { push } from 'connected-react-router';
import dayjs from 'dayjs';
import _ from 'lodash';

import * as ActionTypes from '../../constants/ActionTypes';
import API from '../../helpers/api';

export function onImportantNotesViewSubmit() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.SUBMIT_START_APPLICATION_REQUEST,
			payload: { loadingSubmit: true }
		});

		const body = {
			application: {
				current_step: 1,
				current_date: dayjs().toISOString()
			}
		};

		const response = await API.important_note.createApplication(body);

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.SUBMIT_START_APPLICATION_ERROR,
				payload: {
					loadingSubmit: false,
					...(_.get(response, 'meta.code') !== 409 && { meta: response.meta })
				}
			});

			if (response.meta.code === 409) {
				const { application } = response.data;
				dispatch(push(`/application?step=${application.current_step}&application_id=${application._id}`));
			}
			return;
		}

		const { application } = response.data;

		dispatch({
			type: ActionTypes.SUBMIT_START_APPLICATION_SUCCESS,
			payload: {
				loadingSubmit: false,
				application,
				meta: response.meta
			}
		});

		dispatch(push(`/application?step=${application.current_step}&application_id=${application._id}`));
	};
}

export function getEvent() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_EVENT_REQUEST,
			payload: { loading: true }
		});

		const query = {
			current_date: dayjs().toISOString()
		};

		const response = await API.important_note.getEvent(query);

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_EVENT_ERROR,
				payload: {
					meta: response.meta,
					loading: false
				}
			});
			return;
		}

		const { event } = response.data;

		dispatch({
			type: ActionTypes.GET_EVENT_SUCCESS,
			payload: {
				loading: false,
				event,
				meta: response.meta
			}
		});
	};
}

export function resetImportantNotesPage() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_START_APPLICATION_PAGE
		});
	};
}

export function resetImportantNotesMeta() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_START_APPLICATION_META
		});
	};
}